<template>
  <div class="header-wrapper">
    <div class="header">
      <div class="header-images">
        <img
          class="menu"
          src="~@/assets/menu.svg"
          alt=""
          @click="$router.push('/')"
        />
        <img
          class="logo"
          src="~@/assets/Logo_penascal_kooperativa-color.png"
          alt=""
        />
      </div>
      <h2>ESCUELA DE HOSTELERÍA BOLUETABARRI</h2>
      <h2 class="title-color">BOLUETABARRI OSTALARITZA ESKOLA</h2>
      <div class="message">
        <b>MENÚS DEL DÍA</b><br />
        De lunes a viernes en horario de 13.00h a 15.30h.
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.header-wrapper {
  text-align: center;
  padding-top: 15px;
}

img.logo {
  max-height: 55px;
  position: absolute;
  top: 15px;
  left: 15px;
  max-width: 25%;
}

.title-color {
  color: rgb(111, 107, 107);
}

.message {
  position: absolute;
  top: 15px;
  right: 15px;
  border: 1px solid #ccc;
  padding: 12px;
  width: 32%;
  font-size: 75%;
}

@media only screen and (max-width: 490px) {
  h2,
  h3 {
    font-size: 1rem;
  }
}
@media print {
  img.logo {
    top: 0px;
    left: 0px;
  }
  .message {
    top: 0px;
    right: 0px;
  }
}
</style>
